export * from './genModalBody'
export * from './genPayload'
export * from './genDefaultValues'
export * from './genValidation'
export * from './objHelper'

export const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1)